export default __webpack_public_path__ + "static/media/kobieta.4a32ee81.svg";